/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  get(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    const queryString = queryParams.toString();
    const url = queryString ? `${this.url}?${queryString}` : this.url;
    return axios.get(url);
  }

  createWhatsappCompaign(data) {
    // eslint-disable-next-line no-undef
    return axios.post(`${this.url}/create_whatsapp_campaign`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  sendToSingleContact(accountId, data) {
    // eslint-disable-next-line no-undef
    return axios.post(
      `/api/v1/accounts/${accountId}/campaigns/send_to_single_contact`,
      data
    );
  }

  createFromSegment(data) {
    return axios.post(`${this.url}/create_from_segment`, data);
  }
}

export default new CampaignsAPI();
